export default "__VITE_ASSET__B$xbsy76__"